import React from "react";
import * as Sentry from "@sentry/react";
import axios from "axios";
import { Loading } from "components/common";
import useMount from "utils/hooks/useMount";

const { REACT_APP_BACKEND_URL, REACT_APP_DOMAIN } = process.env;

const ChargeBeePaymentMethod = () => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  useMount(() => {
    const handleRedirect = async () => {
      let response;
      try {
        response = await axios.get(
          `${REACT_APP_BACKEND_URL}/boost/chargeBeePaymentMethod?code=${code}`,
        );
      } catch (err) {
        Sentry.captureException(err);
        window.localStorage.removeItem("jwt");
        window.location.assign(`${REACT_APP_DOMAIN}/dashboard/login?redirect_uri=/boost`);
      }

      if (response?.data?.redirectRoute?.toLowerCase().startsWith("https://")) {
        window.location.assign(response.data.redirectRoute);
      } else {
        window.location.assign(`${REACT_APP_DOMAIN}/dashboard/login?redirect_uri=/boost`);
      }
    };
    handleRedirect();
  });

  // @ts-expect-error
  return <Loading />;
};

export default ChargeBeePaymentMethod;
